import { Fragment, PureComponent, ReactNode } from 'react';
import { CALCULATORS } from '../../../../../constants';
import { connect } from 'react-redux';
import { CALCULATORS_NAMES, CALCULATOR_RESULTS_NAME, CALCULATOR_VIEW } from '../calculatorsTypes';
import { GlobalState } from '../../../../../store/reducers';
import { CalculatorEntity } from '../../../../../store/types/prescription';
import { CalculatorConfig, CalculatorResultsCell } from '../CalculatorsResultCell';
import { getCalcultorPadConfig } from '../../../../../store/selectors/session';
import { CalculatorsConfig } from '../../../../../api/pushGenie';

export type CalculatorMetaDataType = {
    name: CALCULATORS_NAMES;
    title: string;
    api: string;
    result: {
        id: string;
        name: CALCULATOR_RESULTS_NAME;
    };
};

interface Props {
    containerId?: string;
    onElementUpdate: (option: CalculatorEntity, index?: number) => void;
    onElementDelete: (id: string, index?: number) => void;
    vitals?: ReadonlyArray<CalculatorEntity>;
    calculatorsConfig?: CalculatorsConfig;
    openCalculator: (calc: CalculatorConfig) => void;
}

class CalculatorResults extends PureComponent<Props> {
    onInputChange = (resultId: string, value: string) => {
        const { onElementUpdate, onElementDelete, vitals } = this.props;

        const result = vitals?.find((vital) => vital.id === resultId);
        const resultIndex = vitals?.findIndex((vital) => vital.id === resultId);

        if (!value) {
            result && onElementDelete(result.id);
            return;
        }

        if (result) {
            onElementUpdate(
                {
                    ...result,
                    value: {
                        qt: value,
                        unit: '',
                    },
                },
                resultIndex,
            );
        } else {
            const result = CALCULATORS.filter((calc) => calc.view === CALCULATOR_VIEW.VITALS).find(
                (calc) => calc.result.id === resultId,
            )?.result;

            result &&
                onElementUpdate({
                    id: result.id,
                    name: result.name,
                    dis_name: result.name,
                    value: {
                        qt: value,
                        unit: '',
                    },
                });
        }
    };

    render(): ReactNode {
        const { vitals, openCalculator, calculatorsConfig, containerId } = this.props;

        const shownCalculators = CALCULATORS.filter(
            (calc) => calc.view === CALCULATOR_VIEW.VITALS,
        ).filter((calc) =>
            calculatorsConfig?.selectedItems?.find((calcConfig) => calcConfig.key === calc.name),
        );

        if (!shownCalculators.length) {
            return null;
        }

        return (
            <Fragment>
                <div className="flex flex-wrap items-center gap-x-16 gap-y-12 border-t border-darwin-neutral-100 mt-6 pt-8 text-14 font-400">
                    <div className="flex items-center text-12 font-700 uppercase space-x-6 mr-6">
                        <p>calculators:</p>
                    </div>
                    {shownCalculators.map((calc) => {
                        const calculatorConfigData = {
                            id: calc.result.id,
                            resultName: calc.result.name,
                            calculatorName: calc.name,
                            resultType: calc.result.type,
                            isNewView: calc.isNewView,
                        };
                        return (
                            <CalculatorResultsCell
                                containerId={containerId}
                                vitals={vitals}
                                calculatorConfigData={calculatorConfigData}
                                onInputChange={this.onInputChange}
                                openCalculatorPopUp={openCalculator}
                            />
                        );
                    })}
                </div>
            </Fragment>
        );
    }
}

export default connect((state: GlobalState, props: { calculatorsConfig?: CalculatorsConfig }) => ({
    calculatorsConfig: props.calculatorsConfig || getCalcultorPadConfig(state),
}))(CalculatorResults);
